import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    makeStyles
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { closeAddItemsDialog } from "./items-add-slice";
import { db } from "../../../../firebase";
import { useEffect, useState } from "react";
import { addItemsService, getItemCategoriesListService, getItemStatusListService, getItemTypesListService } from "./items-add-service";
import { showErrorSnackbar } from "../../../shared/snackbar/snackbar-slice";

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#111111",
        color: "#fbbbd3",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    buttonText: {
        color: "#111111",
        '&:hover': {
            backgroundColor: '#fbbbd3',
            color: '#111111',
        },
    },
    title: {
        background:"#111111",
    },
    text: {
        color: "#111111",
    },
}));

const initiaFormData = {
    code: "",
    name: "",
    description: "",
    pieces: 0,
    original_price: 0,
    increase: 0,
    unit_price: 0,
    rent_price: 0,
    rent_percent: 0,
    deposit: 0,
    deposit_percent: 0,
    type: "",
    status: "",
    category: "",
};

const ItemsAdd = () => {
    const classes = useStyles();
    const showDialog = useSelector((state) => state.itemsAddSlice.showDialog);
    const isLoading = useSelector((state) => state.itemsAddSlice.isLoading);
    const itemTypesList = useSelector((state) => state.itemsAddSlice.itemTypesList);
    const itemStatusList = useSelector((state) => state.itemsAddSlice.itemStatusList);
    const itemCategoriesList = useSelector((state) => state.itemsAddSlice.itemCategoriesList);
    const [formData, setFormData ] = useState(initiaFormData);
    const [isSelectStatusDisabled, setIsSelectStatusDisabled ] = useState(true);
    const dispatch = useDispatch();

    // get data
    useEffect(() => {
        if (showDialog) {
            const fetchItemTypesData = async () => {
                try {
                    await getItemTypesListService(dispatch, db, "item_types");
                } catch(e) {
                    dispatch(showErrorSnackbar("Something went wrong while trying to fetch item types."));
                    console.error("ItemsAdd fetchItemTypesData error: ", e);
                }
            };
            const fetchItemStatusData = async () => {
                try {
                    await getItemStatusListService(dispatch, db, "item_status");
                } catch(e) {
                    dispatch(showErrorSnackbar("Something went wrong while trying to fetch item status."));
                    console.error("ItemsAdd fetchItemStatusData error: ", e);
                }
            };
            const fetchItemCategoriesData = async () => {
                try {
                    await getItemCategoriesListService(dispatch, db, "item_categories");
                } catch(e) {
                    dispatch(showErrorSnackbar("Something went wrong while trying to fetch item categories."));
                    console.error("ItemsAdd fetchItemCategoriesData error: ", e);
                }
            };
            fetchItemTypesData();
            fetchItemStatusData();
            fetchItemCategoriesData();
        }
    }, [showDialog, dispatch]);

    // check type length
    useEffect(() => {
        if (formData.type?.length) {
            setIsSelectStatusDisabled(false);
        } else {
            setIsSelectStatusDisabled(true);
        }
    }, [formData.type]);

    // handle input
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value
        });
    };

    // handle add
    const handleAddSubmit = async (e) => {
        e.preventDefault();  
       
        try {
            await addItemsService(dispatch, db, "items", formData);
          } catch (e) {
            console.error("Error adding document: ", e);
          }
        handleAddClose();
    };

    // handle close add
    const handleAddClose = () => {
        setFormData(initiaFormData);
        dispatch(closeAddItemsDialog());
    };
          
    return (
        <Dialog
            open={showDialog}
        >
            <DialogTitle className={classes.title}>
                Add Item
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="filled-basic"
                            label="Code"
                            variant="filled"
                            fullWidth
                            name="code"
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="filled-basic"
                            label="Name"
                            variant="filled"
                            fullWidth
                            name="name"
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="filled-basic"
                            label="Description"
                            variant="filled"
                            fullWidth
                            name="description"
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="filled-basic"
                            label="Original Price"
                            variant="filled"
                            fullWidth
                            name="original_price"
                            onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl variant="filled" fullWidth>
                            <InputLabel id="type-select">Type</InputLabel>
                            <Select
                                id="type-select-id"
                                label="Type"
                                labelId="type-select"
                                onChange={handleInputChange}
                                name="type"
                                value={formData.type}
                                displayEmpty
                            >
                                {itemTypesList.map((type) => (
                                    <MenuItem key={type.id} value={type.name}>
                                        {type.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl variant="filled" fullWidth>
                            <InputLabel id="status-select">Status</InputLabel>
                            <Select
                                id="status-select-id"
                                label="Status"
                                labelId="status-select"
                                onChange={handleInputChange}
                                name="status"
                                value={formData.status}
                                displayEmpty
                                disabled={isSelectStatusDisabled}
                            >
                                {itemStatusList.map((status) => {
                                    const isDisabled =
                                    formData.type === "For rent" ?
                                    (status.name === "Available" || status.name === "Out of stock")
                                    : (status.name === "Rented" || status.name === "Open for rent" || status.name === "Reserved");

                                    return (
                                    <MenuItem
                                        key={status.id}
                                        value={status.name}
                                        disabled={isDisabled}
                                    >
                                        {status.name}
                                    </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormControl variant="filled" fullWidth>
                            <InputLabel id="category-select">Category</InputLabel>
                            <Select
                                id="category-select-id"
                                label="Category"
                                labelId="category-select"
                                onChange={handleInputChange}
                                name="category"
                                value={formData.category}
                                displayEmpty
                            >
                                {itemCategoriesList.map((category) => (
                                    <MenuItem key={category.id} value={category.name}>
                                        {category.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    {
                        formData.type === "For rent" && (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        id="filled-basic"
                                        label="Rent %"
                                        variant="filled"
                                        fullWidth
                                        name="rent_percent"
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        id="filled-basic"
                                        label="Deposit %"
                                        variant="filled"
                                        fullWidth
                                        name="deposit_percent"
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                            </>
                        )
                    }
                    {
                        formData.type === "For sale" && (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        id="filled-basic"
                                        label="Increase %"
                                        variant="filled"
                                        fullWidth
                                        name="increase"
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                            </>
                        )
                    }
                    <Grid item xs={12} sm={6}>
                        <TextField
                            id="filled-basic"
                            label="Piece(s)"
                            variant="filled"
                            fullWidth
                            name="pieces"
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    className={classes.button}
                    onClick={handleAddSubmit}
                    disabled={isLoading}
                >
                    {
                        isLoading ? (
                            "Adding..."
                        ) : (
                            "Add"
                        )
                    }
                </Button>
                <Button
                    variant="text"
                    className={classes.buttonText}
                    onClick={handleAddClose}
                    disabled={isLoading}
                >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ItemsAdd;